import SelectField from "components/controls/SelectField";
import { set } from "date-fns";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { EAttachmentType, ETaxonomy, SelectItem } from "library/types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  handleAttachmentTypeChange: (attachmentType: SelectItem | null) => void;
  attachmentType: SelectItem | null;
};

export function AttachmentTypeSelect({
  handleAttachmentTypeChange,
  attachmentType,
}: Props) {
  const { t } = useTranslation();
  const attachmentTypeOptions = useTaxonomyOptions(
    ETaxonomy.AttachmentType
  ).filter((option) => option.code !== EAttachmentType.NORMAL); // Exclude employee consent from the list

  const consentAttachment = attachmentTypeOptions.find(
    (item) => item.code === EAttachmentType.EMPLOYEE_CONSENT
  );
  useEffect(() => {
    if (attachmentType) return; // If attachment type is already set, do not change it
    handleAttachmentTypeChange(consentAttachment); //set employee consent as default attachment type
  }, []);

  return (
    <SelectField
      setFieldValue={(_, value) => {
        handleAttachmentTypeChange(value);
      }}
      value={attachmentType}
      label={t("hbh.attachmentType.label")}
      options={attachmentTypeOptions}
      name={"attachmentType"}
    />
  );
}
